import PropTypes from 'prop-types';

export const ProductAliasPropType = PropTypes.shape({
  aliasSKU: PropTypes.string,
  productAliasId: PropTypes.string,
  storeId: PropTypes.string,
});
